import React from "react";
import abbie2 from "../assets/abbie-2.jpg";
import useAnimation from "../components/useAnimation";

const About = () => {
  const isAnimating = useAnimation(1500);

  return (
    <div>
      {/* <div className="relative min-h-screen">
      <div className="fixed inset-0 bg-lightBrown -z-10"></div> */}
      {isAnimating && (
        <div className="fixed inset-0 z-50 bg-darkBrown animate-slideUp"></div>
      )}
      <div className="pt-16 pl-4 md:pt-[4rem]  md:pl-[6rem]">
        <h1 className="font-extrabold text-7xl md:text-Rem11">
          About.
          <span className="font-semibold text-4xl pl-4 md:text-8xl md:pl-16 ">
            Yu Luo
          </span>
        </h1>
        <div className="flex flex-col pt-2 md:pt-1 md:ml-8">
          <div className="flex flex-row">
            <div className="flex items-center w-1/2 md:w-1/3 md:ml-8">
              <img
                src={abbie2}
                style={{
                  borderRadius: "100px 200px 90px 160px",
                }}
                alt="abbie2"
              />
            </div>

            <div className="flex items-center flex-col mt-4 text-2xl md:pb-6 md:text-5xl md:mt-8">
              <p className="p-2 md:-ml-[20%] font-semibold ">
                Hi! You can call me Abbie :){" "}
              </p>
              <p className="font-normal p-1 pl-8 text-xl md:pl-[10%] md:text-4xl">
                a frontend software engineer.
              </p>
              {/*------------------------------ desktop view table ------------------------------*/}
              <table
                className="hidden md:block border-separate mx-[8%] pt-8 "
                style={{ borderSpacing: "4rem 0" }}
              >
                <tbody>
                  <tr>
                    <td className="p-4 text-xl align-top w-1/2">
                      <h2 className="font-bold text-2xl underline">
                        PROGRAMMING LANGUAGES
                      </h2>
                      <p className="font-medium">
                        {" "}
                        JavaScript | TypeScript | HTML | CSS | Java | Python |
                        PHP
                      </p>
                    </td>
                    <td className=" p-4 text-xl align-top w-1/2">
                      <h2 className="underline font-bold text-2xl">TOOLS</h2>
                      <p className="font-medium">
                        Node.js | Next.js | React | React Native | Tailwind CSS
                        | Material UI | AWS | MySQL | MongoDB | Git | CI/CD |
                        Figma
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="m-4   ">
            {" "}
            {/*------------------------------ mobile view table ------------------------------*/}
            <table
              className="md:hidden  mb-8 pb-4 "
              style={{ borderSpacing: "1 0" }}
            >
              <tbody>
                <tr>
                  <td className=" p-1 align-top w-1/2">
                    <h2 className="font-bold underline">
                      PROGRAMMING LANGUAGES
                    </h2>
                    <p>
                      JavaScript | TypeScript | HTML | CSS | Java | Python | PHP
                    </p>
                  </td>
                  <td className=" p-1 align-top w-1/2">
                    <h2 className="underline font-bold ">TOOLS</h2>
                    <p>
                      Node.js | Next.js | React | React Native | Tailwind CSS |
                      Material UI | AWS | MySQL | MongoDB | Git | CI/CD | Figma
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            {/* --------------------------------- content -----------------------------------*/}
            <div className="md:pl-10 md:mr-16 md:my-8">
              <p className="pb-4 md:pr-16 md:text-2xl ">
                I'm a passionate Front-End Developer with a keen eye for
                aesthetics and a deep appreciation for beautifully crafted
                designs. My journey in web development is driven by a desire to
                create seamless, intuitive, and visually appealing user
                experiences.
              </p>
              <p className="pb-4 md:pr-16 md:text-2xl ">
                Beyond coding, I’ve self-taught Figma to better translate
                creative ideas into functional designs, merging technical
                expertise with artistic vision.
              </p>
              <p className="pb-4 md:pr-16  md:text-2xl ">
                Here, you'll find a collection of my projects that reflect my
                dedication to both form and function. Let’s create something
                beautiful together!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default About;
